import {EventEmitter2} from 'eventemitter2'
import Promise from 'bluebird'
import request from 'superagent'

Promise.config({
  cancellation: true,
})

request.Request.prototype.then = function (onFulfilled, onRejected) {
  let promise = new Promise((resolve, reject, onCancel) => {
    let req = this.end((err, res) => {
      if (err) reject(err)
      else resolve(res)
    }).on('error', reject)
    onCancel(() => {
      req.abort()
    })
  })
  return promise.then(onFulfilled, onRejected)
}

class APIClient extends EventEmitter2 {
  constructor (apiEndpoint, apiEndpointV2, subAPIs) {
    super()
    this.apiEndpoint = apiEndpoint
    this.apiEndpointV2 = apiEndpointV2
    this.adminApiEndpoint = apiEndpoint + 'admin/'
    this.token = null
    this.staffToken = null
    this.defaultTimeout = 60000

    this.plugins = {
      checkError: (request) => {
        let origEnd = request.end
        request.end = (fn) => {
          return origEnd.call(request, (err, res) => {
            if (err && !res) {
              // サーバが死んでいるときなど
              console.error(`Unexcepted request error: ${request.url}, ${err}`)
              this.emit('error', err)
            } else {
              if (!res.ok) {
                switch (res.status) {
                  case 401:
                    this.emit('error', err)
                    break
                  case 404:
                  case 409:
                    // case 429: // Too Many Requests (throttled)
                    // 無視する
                    break
                  case 408:
                    // timeout
                    // falls through
                  case 504:
                    break
                  default:
                    console.error('Unexcepted request error', err, res)
                    this.emit('error', err, res)
                }
              } else {
                request.emit('success', res)
              }
              fn(err, res)
            }
            request.emit('finish', err, res)
          })
        }
        return request
      },
      setToken: (request) => {
        if (this.token) {
          return request.set('Authorization', 'JWT ' + this.token)
        }
        return request
      },
      setStaffToken: (request) => {
        if (this.staffToken) {
          return request.set('X-Staff-Token', this.staffToken)
        }
        return request
      },
      setDefaultTimeout: (request) => {
        return request.timeout(this.defaultTimeout)
      },
      setAccept: request => {
        return request.set('Accept', 'application/json')
      },
    }
    subAPIs(this)
  }

  init () {
  }

  setToken (token) {
    this.token = token
  }

  setStaffToken (token) {
    this.staffToken = token
  }
}
APIClient.request = request

// HTTP
// superagent を生で使うこともできるが、APIClientのメソッドを使うことで、
// 頻繁に使うプラグインのセットを省略できる

;[ 'get', 'head', 'del', 'patch', 'post', 'put', 'options' ].forEach(method => {
  APIClient.prototype[method] = function () {
    let req = request[method].apply(request, arguments)
      .use(this.plugins.setToken)
      .use(this.plugins.setStaffToken)
      .use(this.plugins.setAccept)
      .use(this.plugins.setDefaultTimeout)
      .use(this.plugins.checkError)
      .on('response', res => {
        this.emit('response', res)
      })
    this.emit('request', req)
    return req
  }
})

request.parse['application/json'] = function (body) {
  let data = JSON.parse(body)
  if ('data' in data && 'message' in data) {
    return data.data
  }
  return data
}

export default APIClient



// WEBPACK FOOTER //
// ./src/request/index.js